/* global Modernizr */

import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/optimumx/ls.optimumx';
import './lazysizes-progressive';

Object.assign(lazySizes.cfg, {

  /* Viewport expansion for pre-loading (px) */
  expand: 1000,

  /* Increase viewport expansion by factor X when idle */
  expFactor: 2,

  /* Pre-load images after page load to fix object-fit polyfill bug */
  preloadAfterLoad: !Modernizr.objectfit,

  /* Limit pixel density (see function below) */
  constrainPixelDensity: false,

  /* Custom function to calculate pixel density (if enabled above) */
  getOptimumX() {
    let dpr = window.devicePixelRatio || 1;
    dpr = dpr > 1.5 ? dpr * 0.75 : dpr;
    /* Max screen density: 2.0 */
    return Math.min(Math.round(dpr * 100) / 100, 2);
  },
});

lazySizes.init();
